import { api } from "./axios";

export interface HideApiKeyMasked {
  id: number;
  code_masked: string;
  label: string;
  is_active: boolean;
  priority: number;
  last_sync_at: string | null;
  last_sync_ok: boolean | null;
  last_error: string | null;
  created_at: string;
}

export interface HideKeyInput {
  code?: string;
  label?: string;
  priority?: number;
}

export interface SuccessResponse {
  success: boolean;
  error?: string;
}

export const fetchHideKeys = () =>
  api.get<{ keys: HideApiKeyMasked[] }>("/api/admin/hide-keys");

export const createHideKey = (input: {
  code: string;
  label?: string;
  priority?: number;
}) =>
  api.post<SuccessResponse & { id?: number; is_active?: boolean }>(
    "/api/admin/hide-keys",
    input
  );

export const updateHideKey = (id: number, input: HideKeyInput) =>
  api.put<SuccessResponse>(`/api/admin/hide-keys/${id}`, input);

export const deleteHideKey = (id: number) =>
  api.delete<SuccessResponse>(`/api/admin/hide-keys/${id}`);

export const activateHideKey = (id: number) =>
  api.post<SuccessResponse>(`/api/admin/hide-keys/${id}/activate`);

export const syncUpstreamsNow = () =>
  api.post<{ success: boolean; mode: string }>("/api/upstreams/sync");
